// extracted by mini-css-extract-plugin
export var chip = "_do-0";
export var filterDropdown = "_do-5";
export var filterItem = "_do-6";
export var icon = "_do-1";
export var removeButton = "_do-3";
export var removeIcon = "_do-4";
export var separator = "_do-2";